"use strict";

import cartService from "@/services/cart.service";

export default {
  namespaced: true,
  state: {
    cart: []
  },
  getters: {
    data(state) {
      return state.cart;
    },
  },
  mutations: {
    ["SET_CART"]( state, payload ) {
      state.cart = payload;
    },
  },
  actions: {
    addTocart({ commit }, item) {
        const result = cartService.addTocart(item)
        commit("SET_CART", result);
        return result
    },
    
    saveCart({ commit },cart) {
        const result = cartService.saveCart(cart)
        commit("SET_CART", result);
        return result
    },

    removeItem({ commit }, index) {
        const result = cartService.removeItem(index)
        commit("SET_CART", result);
        return result
    },

    getCart({ commit }) {
        const result = cartService.getCart()
        commit("SET_CART", result);
        return result
    }
  },
};
